//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { i18n } from '@/boot/i18n';
export default {
  name: 'FibYesNo',
  props: {
    value: {
      type: Object
    }
  },
  data: function data() {
    return {
      icons: [{
        val: 'yes',
        label: i18n.t('common.button.yes'),
        src: 'statics/icons/yes.svg'
      }, {
        val: 'no',
        label: i18n.t('common.button.no'),
        src: 'statics/icons/no.svg'
      }],
      showInput: false,
      canShow: {
        no: false,
        yes: false
      }
    };
  },
  computed: {
    style: function style() {
      var theme = this.$store.getters['theme/theme'];
      return {
        color: theme.primaryColor
      };
    }
  },
  created: function created() {
    this.canShow.no = this.$attrs.noFollowUp;
    this.canShow.yes = this.$attrs.yesFollowUp;
  },
  methods: {
    handleDecisionChange: function handleDecisionChange(value) {
      this.showInput = this.canShow[value];
      this.$emit('input', {
        decision: value,
        details: this.value ? this.value.details : null
      });
    },
    handleDetailsChange: function handleDetailsChange(value) {
      this.$emit('input', {
        decision: this.value ? this.value.decision : null,
        details: value
      });
    }
  }
};